module.exports = __webpack_public_path__ + "static/media/big-muffler-bg.0e668199.jpg";